module.exports = __webpack_public_path__ + "img/logo-hotelv-frederiksplein--dark.9a57c4744432ae863d41f50c39869709.svg";